import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { RoomInfoProducts } from "@b2bportal/lodging-api";
import { AmenityIcon } from "@tenant/hotels";
import { Dialog, DialogContent, DialogTrigger } from "@tenant/ui";
import clsx from "clsx";
import { ImageCarousel } from "../ImageCarousel";
import { useHotelRoomCardDialog } from "./hooks";
import defaultStyles from "./HotelRoomCardDialog.module.scss";

export interface HotelRoomCardDialogComponentProps
  extends PlatformComponentProps {
  room: RoomInfoProducts;
  nightCount: number;
}

const COMPONENT_KEY = CoreHotelsComponent.HotelRoomCardDialog;

export const HotelRoomCardDialog = (
  props: HotelRoomCardDialogComponentProps
) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className, children } = props;
  const {
    context,
    text,
    handlers: { emitOpenDetailsEvent },
  } = useHotelRoomCardDialog(props);

  return (
    <Dialog>
      <DialogTrigger
        className={clsx(cn("room-details-link"), className)}
        onClick={() => emitOpenDetailsEvent()}
      >
        {text.viewDetails}
      </DialogTrigger>
      <DialogContent title={text.roomName}>
        <div className={clsx(cn("content"))}>
          {context.roomImages.length > 0 && (
            <div className={cn("carousel-container")}>
              <ImageCarousel
                imageUrlsArray={context.roomImages}
                hideArrows={context.roomImages.length <= 1}
                hideDots={false}
              />
            </div>
          )}

          <div className={cn("section", ["amenities"])}>
            <h4 className={cn("section-title")}>{text.roomDetailsTitle}</h4>
            <ul className={cn("amenity-list")}>
              {context.amenities.map(({ amenity, displayName }) => (
                <li key={amenity} className={cn("amenity-item")}>
                  <AmenityIcon
                    className={cn("amenity-icon")}
                    amenity={amenity}
                    alt={displayName}
                  />
                  {displayName}
                </li>
              ))}
            </ul>
          </div>

          {text.roomDescription != null && text.roomDescription !== "" ? (
            <div className={cn("section", ["description"])}>
              <div
                className={cn("description-content")}
                dangerouslySetInnerHTML={{ __html: text.roomDescription }}
              />
            </div>
          ) : null}
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
};
